import {NgModule} from '@angular/core';
import {IntersectionDirective} from './intersection/intersection.directive';
import {WaypointDirective} from './waypoint/waypoint.directive';

@NgModule({
  declarations: [IntersectionDirective, WaypointDirective],
  exports: [IntersectionDirective, WaypointDirective],
})
export class IntersectionsModule {}
